import { Component, OnDestroy, OnInit } from '@angular/core';

import { filter, map, pairwise, startWith, Subscription, tap } from 'rxjs';

import { Location } from '@shared/location/models';
import { IParty } from '@tablesready/common-ui';
import { HeaderTitleService } from '@tablesready/frontend-header';
import { AuthRestaurantService } from '@tablesready/frontend-store';

@Component({
  selector: 'tablesready-import',
  templateUrl: './import.component.html',
})
export class ImportComponent implements OnInit, OnDestroy {
  location: Location;
  parties: IParty[] = [];

  private readonly subscription = new Subscription();

  constructor(
    private readonly headerService: HeaderTitleService,
    private readonly authRestaurantService: AuthRestaurantService,
  ) { }

  ngOnInit(): void {
    const title = 'Import Reservations';
    this.headerService.setDataForRoute('import', { title });

    const userSubscription = this.authRestaurantService.select()
      .pipe(
        startWith(null),
        pairwise(),
        filter(([prev, current]) => prev?.location?._id !== current.location?._id),
        map(([prev, current]) => current),
        tap((res) => {
          this.location = res.location;
          this.parties = [];
        }),
      )
      .subscribe();
    this.subscription.add(userSubscription);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onData(parties: IParty[]): void {
    this.parties = parties;
  }
}
